import { styled } from "@monolith-forensics/monolith-ui";
import { useFileUploader } from "../../Hooks";
import { useEffect, useState } from "react";
import { Header } from "./Header";
import { UploadItem } from "./UploadItem";

const StyledContainer = styled.div`
  &.file-uploader.closed {
    height: 45px;
    overflow: hidden;
  }
  &.file-uploader {
    position: absolute;
    bottom: 10px;
    right: 0;
    margin: 20px 20px 0 20px;
    border-radius: 5px;
    width: 350px;
    max-height: 350px;
    background-color: ${({ theme }) => theme.palette.background.alt};
    border: 1px solid ${({ theme }) => theme.palette.divider};
    z-index: 2000;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    font-size: 10px;
  }
  &.file-uploader .uploader-content {
    max-height: calc(350px - 50px);
    overflow-y: auto;
    padding: 5px;
  }
`;

export const FileUploadManager = () => {
  const { files, uploading, clearFiles } = useFileUploader();
  const [open, setOpen] = useState(true);
  const [visible, setVisible] = useState(uploading);

  const handleMinimize = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (uploading) {
      setVisible(true);
    }
  }, [uploading]);

  if (!visible) return null;

  return (
    <StyledContainer className={`file-uploader ${open ? "" : "closed"}`}>
      <Header
        onMinClick={handleMinimize}
        open={open}
        toggleVisibilty={() => {
          setVisible(!visible);
          clearFiles();
        }}
      />
      <div className="uploader-content">
        {files.map((file, index) => {
          return <UploadItem key={index} file={file} />;
        })}
      </div>
    </StyledContainer>
  );
};
